import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'sc-json-highlight',
  standalone: true,
  imports: [],
  templateUrl: './json-highlight.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './json-highlight.component.scss'
})
export class JsonHighlightComponent {
  json = input.required<string>();

  highlightedJson = computed(() => this.syntaxHighlight(this.json()));

  private syntaxHighlight(json): string {
    if (typeof json != 'string') {
      json = JSON.stringify(json, null, '\t');
    }

    json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

    return json.replace(
      /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
      (match) => {
        let cls = 'number';

        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = 'key';
          } else {
            cls = 'string';
          }
        } else if (/true|false/.test(match)) {
          cls = 'boolean';
        } else if (/null/.test(match)) {
          cls = 'null';
        }

        return '<span class="' + cls + '">' + match + '</span>';
      }
    );
  }
}
